import { Session } from '@console/common/contexts/AuthContext'
import { UserRole } from '@console/common/services/api'

export function isBetaUser(session: Session | null): boolean {
  return session?.role === UserRole.ADMIN || session?.role === UserRole.R2USER
}
